<app-dialog-wrapper [closable]="false" [isFooterVisible]="false">
  <div class="store-picker">
    <p class="store-picker__hint">
      Please choose a location to continue.
    </p>

    @if (isLoading()) {
      <div class="store-picker__loading">
        <span>Loading locations...</span>
      </div>
    } @else if (stores().length === 0) {
      <div class="store-picker__empty">
        <span>No locations are currently available. Please check back later.</span>
      </div>
    } @else {
      <ul class="store-picker__list">
        @for (store of stores(); track store.domain; let i = $index) {
          <li class="store-picker__item">
            <button
              type="button"
              class="store-picker__card"
              (click)="pick(i)"
            >
              <span class="store-picker__name">{{ store.name }}</span>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</app-dialog-wrapper>
